module.exports = __webpack_public_path__ + "static/year2005-9ddfb4253436ab29bebee660c2b2c3b7.jpg";